import { QueryClient } from "@tanstack/react-query";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 20_000,
        retry: (attempt, error) => {
          const status = error instanceof Error && "status" in error ? Number(error.status) : 0;
          return status >= 400 && status < 500 ? false : attempt < 2;
        },
        refetchOnWindowFocus: true,
      },
      // An operator's send must fail now when offline, never replay on reconnection.
      mutations: { retry: false, networkMode: "always" },
    },
  });
}
